export const getLicenseState = (state) => state.licenseState.isTessaraInstrument;

export const getLicenseIsTessaraInstrument = (state) => state.licenseState.isTessaraInstrument;
